import { render, staticRenderFns } from "./DateInputFormAppend.vue?vue&type=template&id=4fa85d48&scoped=true&"
import script from "./DateInputFormAppend.vue?vue&type=script&lang=js&"
export * from "./DateInputFormAppend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa85d48",
  null
  
)

export default component.exports